import { trackEventSegment } from "api";
import { IUserAgent } from "./../types/ua";
export const getAppleMeta = (router: any, pageProps?: any) => {
  if (pageProps) {
    if (pageProps.product) {
      if (pageProps.sale?.single_offer) {
        const tmp2 = `chooseapp://sales/${encodeURI(pageProps.sale.url)}`;
        return tmp2;
      }
      const tmp1 = `chooseapp://product/${encodeURI(pageProps.product.url)}`;
      return tmp1;
    } else if (pageProps.sale) {
      const path = router.asPath
        .replace("/", "")
        .replace("sale/", "sales/")
        .replace("upcoming/", "sales/")
        .split("?")[0];
      let newLocation = `chooseapp://${encodeURI(path)}`;
      if (
        path.match(/(sales|sale)/) &&
        pageProps.sale &&
        !pageProps.sale.sale_started
      ) {
        newLocation = `chooseapp://${encodeURI(
          path.replace("sales", "preview")
        )}`;
      }

      return newLocation;
    }
  }
  const tmp = "chooseapp:/" + window.location.pathname;
  return tmp;
};

export const getStoreLink = (userAgent: IUserAgent) => {
  const urlIos =
    "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website";
  const urlAndroid =
    "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR";
  return userAgent && userAgent.isAndroid ? urlAndroid : urlIos;
};

export const openURL = (
  userAgent: IUserAgent,
  pathname: string,
  url: string,
  isAnotherDomain: boolean
) => {
  if (
    url.indexOf("https://applinks.") === -1 &&
    url.indexOf("https://www.applinks.") === -1
  ) {
    if (isAnotherDomain) {
      window.location.href === url
        ? window.location.reload()
        : (window.location.href = url);
    } else {
      if (userAgent && !userAgent.isAndroid) {
        if (pathname === "/home") {
          const applinksHost = window.location.host.replace(
            /^(www\.)?/,
            "applinks."
          );
          window.location.href = `https://${applinksHost}/home`;
        } else {
          const newurl = window.location.href.replace(
            /https:\/\/(www\.)?/,
            "https://applinks."
          );
          trackEventSegment("redirect", {
            newurl,
            oldurl: window.location.href,
          });
          window.location.href = newurl;
        }
      } else {
        window.location.href = url;
      }
    }
  } else {
    const storeLink = getStoreLink(userAgent);
    try {
      window.top.location = storeLink as any;
    } catch (e) {
      // openURL(userAgent, pathname, storeLink, true)
    }
  }
};

export const openStore = (userAgent: IUserAgent, pathname: string) => {
  let tmp = [];
  let tryLink = false;

  const storeLink = getStoreLink(userAgent);
  trackEventSegment("openStore", {
    tryLink,
    storeLink,
    pathname,
    userAgent,
  });
  const clearAllTimeOuts = () => {
    tmp.forEach(window.clearTimeout), (tmp = []);
  };
  ["pagehide", "beforeunload", "blur"].forEach((n) => {
    window.addEventListener(n, clearAllTimeOuts);
  }),
    tmp.push(
      window.setTimeout(() => {
        tryLink = true;
        try {
          trackEventSegment("location", {
            tryLink,
            storeLink,
            pathname,
            userAgent,
          });
          window.top.location = storeLink as any;
        } catch (e) {
          trackEventSegment("openURL", {
            tryLink,
            storeLink,
            pathname,
            userAgent,
          });
          openURL(userAgent, pathname, storeLink, true);
        }
      }, 1e3)
    ),
    tmp.push(
      window.setTimeout(() => {
        if (tryLink) {
          const searchParams = new URLSearchParams(window.location.search);
          searchParams.delete("openstore");
          const params = searchParams.toString();
          const newurl =
            "https://www.appchoose.io" +
            window.location.pathname +
            (params ? "?" + params : "");
          trackEventSegment("location2", {
            newurl,
          });
          window.location.href = newurl;
        }
      }, 2e3)
    );
};
